<ion-split-pane #ionSplitPane contentId="main" [when]="showTabsMenu">
  <ion-menu contentId="main">
    <ion-content scrollX="false" scrollY="false" color="background" class="ion-padding">
      <ion-list class="flex flex-col h-full pt-[67.5px] pb-[100px] relative" lines="none">
        <!-- Curve design -->
        <div class="absolute right-0 translate-x-[1px] w-[65px] h-[178px]" [style.top.px]="curveTop"
          [style.bottom.px]="curveBottom">
          <img class="w-full h-full" src="../../../assets/tab-icons/curve.svg" alt="" />
        </div>

        <!-- Tab buttons -->
        <div class="w-full h-full bg-transparent flex flex-col items-center justify-between">
          <div class="flex flex-col items-center gap-[25px]">
            @for (tab of bogProTabs; track $index) {
              @if (tab.hasAccess) {
                <div
                  class="w-[52px] h-[52px] rounded-full flex justify-center items-center transition-all duration-300 ease-in-out"
                  [class]="
                    selectedTab === tab.title
                      ? 'translate-x-2 bg-white shadow-[2px_1px_8px_0px_#00000024]'
                      : 'bg-transparent'
                  "
                  [class.opacity-40]="isTabOfflineDisabled(tab.title)"
                  [class.pointer-events-none]="isTabOfflineDisabled(tab.title)"
                  [class.cursor-not-allowed]="isTabOfflineDisabled(tab.title)"
                  [routerLink]="isTabOfflineDisabled(tab.title) ? null : tab.route"
                  (click)="setCurrentTab(tab.title)">
                  <ion-icon
                    class="text-[30px]"
                    [src]="
                      selectedTab === tab.title
                        ? tab.activeIcon
                        : tab.inactiveIcon
                    ">
                  </ion-icon>
                </div>
                <!-- <img src="../../assets/tab-icons/Vector.png" alt="" class="w-[2px] h-[14px]" /> -->
              }
            }
          </div>

          <div class="flex flex-col items-center gap-[32px]">
            @if (userService.hasUserAccessToModule("settings") | async) {
              <div
                class="w-[52px] h-[52px] rounded-full flex justify-center items-center transition-all duration-300 ease-in-out"
                [class]="
                  selectedTab === 'settings'
                    ? 'translate-x-2 bg-white shadow-[2px_1px_8px_0px_#00000024]'
                    : 'bg-transparent'
                "
                routerLink="/settings"
                (click)="setCurrentTab('settings')">
                <ion-icon
                  class="text-[30px]"
                  [src]="
                    selectedTab === 'settings'
                      ? '../../assets/tab-icons/settings-icon-active.svg'
                      : '../../assets/tab-icons/settings-icon.svg'
                  ">
                </ion-icon>
              </div>
            }

            <!-- Training tab hidden for now
              <div
                class="w-[52px] h-[52px] rounded-full flex justify-center items-center transition-all duration-300 ease-in-out"
                [class]="
                  selectedTab === 'training'
                    ? 'translate-x-2 bg-white shadow-[2px_1px_8px_0px_#00000024]'
                    : 'bg-transparent'
                "
                [class.opacity-40]="isOffline"
                [class.pointer-events-none]="isOffline"
                [class.cursor-not-allowed]="isOffline"
                [routerLink]="isOffline ? null : '/training'"
                (click)="setCurrentTab('training')">
                <ion-icon
                  name="school-outline"
                  class="text-[30px]"
                  [style.color]="selectedTab === 'training' ? '#007382' : '#666'">
                </ion-icon>
              </div>
            -->

            @if (userService.hasUserAccessToModule("admin") | async) {
              <div
                class="w-[52px] h-[52px] rounded-full flex justify-center items-center transition-all duration-300 ease-in-out"
                [class]="
                  selectedTab === 'admin'
                    ? 'translate-x-2 bg-white shadow-[2px_1px_8px_0px_#00000024]'
                    : 'bg-transparent'
                "
                [class.opacity-40]="isOffline"
                [class.pointer-events-none]="isOffline"
                [class.cursor-not-allowed]="isOffline"
                [routerLink]="isOffline ? null : '/admin'"
                (click)="setCurrentTab('admin')">
                <ion-icon
                  class="text-[30px]"
                  [src]="
                    selectedTab === 'admin'
                      ? '../../assets/tab-icons/admin-active.svg'
                      : '../../assets/tab-icons/admin.svg'
                  ">
                </ion-icon>
              </div>
            }
          </div>
        </div>

        <!-- Logout button -->
        <div
          class="w-[46px] h-[46px] absolute bottom-[18px] left-1/2 -translate-x-1/2 rounded-full bg-white flex justify-center items-center"
          [class.opacity-40]="isOffline"
          [class.pointer-events-none]="isOffline"
          [class.cursor-not-allowed]="isOffline"
          (click)="handleLogOut()">
          <ion-icon class="text-[26px]" src="../../assets/tab-icons/logout-icon.svg"></ion-icon>
        </div>
      </ion-list>
    </ion-content>
  </ion-menu>

  <div class="ion-page z-50" id="main">
    <ion-router-outlet id="main"></ion-router-outlet>
  </div>

  @if (isNotificationMenu) {
    <ion-backdrop [visible]="isNotificationMenu" (ionBackdropTap)="handleBackdropClose()"></ion-backdrop>
  }
  @if (isAssessmentModalOpen) {
    <ion-backdrop [visible]="isAssessmentModalOpen"></ion-backdrop>
  }
  @if (isErrorModal) {
    <ion-backdrop [visible]="isErrorModal"></ion-backdrop>
  }

  @if (settingMap.isStructuralAssetSummary.getValue()) {
    <ion-backdrop [visible]="isErrorModal"></ion-backdrop>
  }

  @if (settingMap.isEditorsModalOpenSubject | async) {
    <ion-backdrop [visible]="true"></ion-backdrop>
  }

  @if (settingMap.isFieldSetupSummary | async) {
    <ion-backdrop [visible]="true"></ion-backdrop>
  }

  @if (
    (userService.isAddUserModalOpenSubject | async) ||
    (userService.isEditUserModalOpenSubject | async)
  ) {
    <ion-backdrop [visible]="true"></ion-backdrop>
  }

  @if (registerMaterialService.isRejectionModalOpen | async) {
    <ion-backdrop [visible]="true"></ion-backdrop>
  }

  @if (settingMap.isSecurityModalOpen | async) {
    <ion-backdrop [visible]="true"></ion-backdrop>
  }

  @if (imagePreviewService.isLightboxOpen) {
    <app-image-lightbox
      [images]="imagePreviewService.lightboxImages"
      [startIndex]="imagePreviewService.lightboxStartIndex"
      (close)="imagePreviewService.closeLightbox()">
    </app-image-lightbox>
  }

  <app-summary-modal
    [isOpen]="(summaryModalService.isOpen$ | async) === true"
    (closeModal)="summaryModalService.close()">
  </app-summary-modal>

  <app-cre-modal
    [isOpen]="(creModalService.isOpen$ | async) === true"
    (closeModal)="creModalService.close()">
  </app-cre-modal>

  <app-bog-modal
    [isOpen]="(bogModalService.isOpen$ | async) === true"
    (closeModal)="bogModalService.close()">
  </app-bog-modal>

  <app-excellence-modal
    [isOpen]="(excellenceModalService.isOpen$ | async) === true"
    (closeModal)="excellenceModalService.close()">
  </app-excellence-modal>

  <app-cc-modal
    [isOpen]="(ccModalService.isOpen$ | async) === true"
    (closeModal)="ccModalService.close()">
  </app-cc-modal>

  <app-air-emission-modal
    [isOpen]="(airEmissionModalService.isOpen$ | async) === true"
    (closeModal)="airEmissionModalService.close()">
  </app-air-emission-modal>

  <app-finding-details-modal
    [isOpen]="(findingDetailsModalService.isOpen$ | async) === true"
    (closeModal)="findingDetailsModalService.close()">
  </app-finding-details-modal>

  @if (userService.isFilterModalOpen | async) {
    <ion-backdrop [visible]="true"></ion-backdrop>
  }
  @if (this.ciTimerService.isAddModalOpen | async) {
    <ion-backdrop [visible]="true"></ion-backdrop>
  }
</ion-split-pane>